import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { InstanceService } from '@serengeti/serengeti-resource';
import { ThemeService } from 'src/app/setting/theme/service/theme.service';

export class Area {
  title: string;
  id: string;
  color: any;
  customData: string;
  groupId: string;

	public constructor(title: string, id: string, color: any, customData: string, groupId: string) {
    this.title = title;
    this.id = id;
    this.color = color;
    this.customData = customData;
    this.groupId = groupId;
  }
}

@Injectable({
  providedIn: 'root'
})
export class WizardResourceMapService {

  subject = new Subject<any>();
  mapData = {} as any;

  constructor(
    private instanceService: InstanceService,
    private themeService: ThemeService,
    private translateService: TranslateService
  ) {
    const themeColors = this.themeService.getThemeColors();

    this.translateService.get([
      'dashboard.items.resource-map.legend.0',
      'dashboard.items.resource-map.legend.1',
      'dashboard.items.resource-map.legend.2',
      'dashboard.items.resource-map.legend.3'
    ]).subscribe((messages: any) => {
      this.mapData =
      {
        type: 'map',
        theme: 'blur',
        zoomControl: {
          zoomControlEnabled: true,
          panControlEnabled: false
        },
        dataProvider: {
          map: 'worldLow',
          zoomLevel: 2.0,
          zoomLongitude: 127,
          zoomLatitude: 37,
          areas: []
        },
        areasSettings: {
          rollOverOutlineColor: themeColors.borderColor,
          rollOverColor: themeColors.mainColor,
          alpha: 0.8,
          unlistedAreasAlpha: 0.2,
          unlistedAreasColor: themeColors.fontColor,
          balloonText: '[[title]]: [[customData]] instance(s)',
          autoZoom: true,
          selectedColor: '#CC0000'
        },
        smallMap: {backgroundAlpha: 0,  borderAlpha: 0},
        legend: {
          width: '100%',
          marginRight: 0,
          marginLeft: 10,
          equalWidths: false,
          borderAlpha: 0,
          bottom: 0,
          left: 0,
          data: [
            {
              title: messages['dashboard.items.resource-map.legend.0'],
              color: themeColors.stateDangerColor,
              markerType : 'circle'
            },
            {
              title: messages['dashboard.items.resource-map.legend.1'],
              color: themeColors.stateWarningColor,
              markerType : 'circle'
            },
            {
              title: messages['dashboard.items.resource-map.legend.2'],
              color: themeColors.stateSuccessColor,
              markerType : 'circle'
            },
            {
              title: messages['dashboard.items.resource-map.legend.3'],
              color: themeColors.statePrimaryColor,
              markerType : 'circle'
            }
          ]
        },
        export: {
          enabled: true
        },
        creditsPosition: 'bottom-right',
        pathToImages: 'assets/images/vendor/ammap/'
      };
    });
  }

  load(): Observable<any> {
    return this.instanceService.list().pipe(
			map((instances: any[]) =>  {
        const areas = [];
        instances.forEach(instance=>{
          areas.push({ country : instance.pool.region.cityName, countryCode : instance.pool.region.countryCode, instance : 1 });
        });

        const result = [];
        areas.forEach(function(a) {
            if ( !this[a.country] && !this[a.countryCode] ) {
                this[a.country] = { country: a.country, countryCode: a.countryCode, instance: 0 };
                result.push(this[a.country]);
            }
            this[a.country].instance += a.instance;
        }, Object.create(null));

        const themeColors = this.themeService.getThemeColors();
        result.forEach((element: any) => {
          const count = element.instance;
          let color: string;
          switch (true) {
              case (count <= 10): color = themeColors.stateDangerColor; break;
              case (count <= 50):  color = themeColors.stateWarningColor; break;
              case (count < 100): color = themeColors.stateSuccessColor; break;
              case (count >= 100): color = themeColors.statePrimaryColor; break;
              default:
                console.log('not supported'); break;
          }
          this.mapData.dataProvider.areas.push(new Area(element.country, element.countryCode, color, element.instance, '1'));
        });
        return this.mapData;
      })
		);
  }
}
